(function () {
  if (window.MeasmerizeHandler) return;
  const SCRIPT_SRC = 'https://client.measmerize.com/script.js';
  const SCRIPT_ID = 'measmerize-script';
  const BUTTON_ID = 'measmerize-button';
  const RECOMMENDATION_ID = 'measmerize-recommendation';

  function getButton() {
    return document.getElementById(BUTTON_ID);
  }

  function getRecommendation() {
    return document.getElementById(RECOMMENDATION_ID);
  }

  function syncPair(rec) {
    const btn = rec.previousElementSibling;
    if (!btn || btn.id !== BUTTON_ID) return false;
    const recText = rec.textContent.trim().replace(/:(\S)/, ': $1');
    if (!recText) return false;
    const btnTextEl = btn.querySelector('button > div:last-child');
    if (!btnTextEl) return false;
    if (btnTextEl.textContent.trim() !== recText) {
      btnTextEl.textContent = recText;
    }
    return true;
  }

  function sync() {
    let synced = false;
    document.querySelectorAll('#' + RECOMMENDATION_ID).forEach((rec) => {
      if (syncPair(rec)) synced = true;
    });
    return synced;
  }

  let syncObservers = [];
  function watchRecommendation() {
    while (syncObservers.length) syncObservers.pop().disconnect();
    document.querySelectorAll('#' + RECOMMENDATION_ID).forEach((rec) => {
      if (syncPair(rec)) return;
      const obs = new MutationObserver(() => {
        if (syncPair(rec)) obs.disconnect();
      });
      obs.observe(rec, { childList: true, subtree: true, characterData: true });
      syncObservers.push(obs);
    });
  }

  function remount() {
    if (!window.measmerize) return false;
    try { window.measmerize.button.unMount(); } catch (e) {}
    try { window.measmerize.recommendation.unMount(); } catch (e) {}
    try { window.measmerize.button.mount(); } catch (e) {}
    try { window.measmerize.recommendation.mount(); } catch (e) {}
    return true;
  }

  function injectScript(opts) {
    if (document.getElementById(SCRIPT_ID)) return;
    const s = document.createElement('script');
    s.id = SCRIPT_ID;
    s.src = SCRIPT_SRC;
    s.dataset.brandCode = opts.brandCode;
    s.dataset.productCode = opts.productCode;
    s.dataset.langCode = opts.langCode;
    s.dataset.countryCode = opts.countryCode;
    document.head.appendChild(s);
  }

  function updateProductCode(productCode) {
    const s = document.getElementById(SCRIPT_ID);
    if (s) s.dataset.productCode = productCode;
  }

  function moveTo(container) {
    const btn = getButton();
    const rec = getRecommendation();
    if (!container || !btn) return false;
    let moved = false;
    if (!container.contains(btn)) {
      container.appendChild(btn);
      moved = true;
    }
    if (rec && !container.contains(rec)) {
      container.appendChild(rec);
      moved = true;
    }
    return moved;
  }

  window.MeasmerizeHandler = {
    sync,
    watchRecommendation,
    remount,
    injectScript,
    updateProductCode,
    moveTo,
  };
})();
